import React, { useEffect, useState } from "react";
import Footer from "../components/footer";
import Navbar from "../components/navbar";
import { useSetRole } from "../hooks/setRole";
import { useAuth } from "../services/authProvider";


const Role = (props) => {
  const [roles, setUserRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const { mutate: setRole, isLoading, data } = useSetRole();
  const { updateToken } = useAuth();

  useEffect(() => {
    // Get the user info from localStorage
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.roles && user?.organizations) {
      // Find the active organization
      const activeOrg = user?.organizations?.find(org => org.active === true);
      if (activeOrg) {
        // Filter roles that belong to the active organization
        const orgRoles = user.roles.filter(role => {
          if (role.type === "ORGANIZATION") {
            return role.organizationId === activeOrg.id;
          } else if (role.type === "CLINICAL_LOCATION") {
            return role.organizationId === activeOrg.id;
          }
          return false;
        });

        const validRoles = orgRoles.filter(role => {
          // Filter out USER role from ORGANIZATION type
          if(role.type === "ORGANIZATION" && role.role === 'USER') {
            return false;
          }
          return true;
        });

        // Remove duplicate admin roles - keep ORGANIZATION type, filter out CLINICAL_LOCATION type
        // when both admin roles exist for the same organization
        const uniqueRoles = validRoles.filter(role => {
          // If this is a CLINICAL_LOCATION admin role
          if (role.type === "CLINICAL_LOCATION" && role.role?.endsWith("_ADMIN")) {
            // Check if there's an ORGANIZATION admin role for the same organization
            const orgAdminExists = validRoles.some(
              r => r.type === "ORGANIZATION" &&
                   r.role?.endsWith("_ADMIN") &&
                   r.organizationId === role.organizationId
            );
            // Filter out this CLINICAL_LOCATION admin if an ORG admin exists
            return !orgAdminExists;
          }
          return true;
        });

        setUserRoles(uniqueRoles);
      } else {
        // If no active org, show all roles
        setUserRoles(user.roles);
      }
    }
  }, []);

  const handleSelected = ({ roleType, roleName, id }) => {
    setSelectedRole(roleName);
    setRole({
      roleType: roleType,
      roleName: roleName,
      id: id,
    });
  };
  useEffect(() => {
    if (data?.status === 200 && !isLoading) {
      // Update the access token with the new token from the response
      updateToken(data.data.token);

      // Navigate to appropriate home page based on role
      if (selectedRole === "HEALTH_CARE_PROVIDER" || selectedRole === "CLINICAL_LOCATION_ADMIN") {
        props.history.push("/hcp");
      } else if (selectedRole === "PATIENT") {
        props.history.push("/patient");
      } else if (selectedRole === "FAMILY") {
        props.history.push("/family");
      } else if (selectedRole === "ORG_ADMIN") {
        props.history.push("/admin");
      }
    }
  }, [data, isLoading, selectedRole, props.history, updateToken]);
  
  return (
    <div className="d-flex flex-column h_100">
      <Navbar isPageRole={true} />
      <div className="main">
        <div className="col-lg-4">
          <div className="card border-0 shadow sm">
            <div className="card-body p-5">
              <h4 className="text-center mb-5">Select Role</h4>
              {roles.map(
                (item, key) =>
                  item.role !== "N/A" && (
                    <button
                      key={key}
                      onClick={() =>
                        handleSelected({
                          roleType: item.type,
                          roleName: item.role,
                          id: item.type === "CLINICAL_LOCATION"
                            ? item.clinicalLocationId
                            : item.organizationId,
                        })
                      }
                      className={`btn btn-block hoverActive my-4 py-2 shadow ${
                        selectedRole === item.role && "btn_active"
                      }`}
                    >
                      <small>
                        {item.role === "HEALTH_CARE_PROVIDER"
                          ? "Health Care Provider"
                          : item.role === "PATIENT"
                          ? "Patient"
                          : item.role === "FAMILY"
                          ? "Family"
                          : "Administrator"}
                        {item.type === "CLINICAL_LOCATION" && item.clinicalSiteName && (
                          <> - {item.clinicalSiteName}</>
                        )}
                      </small>
                    </button>
                  )
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Role;
